import commonMixin from '../../mixins/_common';
import flashMessageMixin from '../../mixins/_flash_messages';
import deployReservationCheck from '../../mixins/_deploy_reservation_check';
import modalReserveDeployConfirm from '../../components/deploy/_modal_reserve_deploy_confirm';

/**
 * カテゴリ名を更新するコンポーネント(新規追加 or 更新)
 */
export default {
    name: 'category-edit',
    template: '#category_name_template',
    data() {
        return {
            // 編集中フラグ
            editing: false,
            // 編集中データ
            edit_name: null,
            edit_page_key: null,
            // 反映予約確認モーダルが開かれているか否か
            should_open_reserve_deploy_confirm_modal: false,
        };
    },
    props: {
        // ディスプレイモード
        displayMode: {
            type: String,
            default: 'normal',
            validator: function (value) {
                // プロパティの値は、必ずいずれかの文字列でなければならない
                return ['normal', 'link'].indexOf(value) !== -1;
            }
        },
        // 全カテゴリリスト
        categories: {
            type: Array,
            default: () => ([]),
        },
        // 編集対象のカテゴリデータ
        category_data: {
            type: Object,
            default: () => ({}),
        },
        // 新規フラグ
        add: {
            type: Boolean,
            default: false,
        },
        // 編集不可フラグ
        uneditable: {
            type: Boolean,
            default: false,
        },
        // 子カテゴリ有無
        has_chiled: {
            type: Boolean,
            default: false,
        }
    },
    mixins: [
        commonMixin,
        flashMessageMixin,
        deployReservationCheck,
    ],
    computed: {
        // カテゴリ名
        name: function () {
            if (this.category_data.name) {
                let replacedName = this.category_data.name.replace(/;amp;/g, ';');
                return this.$_unEscape(replacedName);
            }
        },
    },
    components: {
        // 反映予約確認モーダルコンポーネント
        'modal-reserve-deploy-confirm': modalReserveDeployConfirm,
    },
    emits: [
        'update-categories',
        'selected-category',
        'clicked-delete-btn',
    ],
    methods: {
        // ディスプレイモードが通常か
        isDisplayModeNormal: function () {
            return this.displayMode === 'normal';
        },
        // 編集フォームを開く
        edit: function () {
            this.editing = true;
            let replacedName = this.category_data.name.replace(/;amp;/g, ';');
            this.edit_name = this.$_unEscape(replacedName);
            this.edit_page_key = this.category_data.page_key;
        },
        // 編集を終了する
        close: function () {
            this.editing = false;
            // 新規キャンセルの場合削除する
            if (this.add) {
                const categories = this.getDeleteCategories();
                this.emitUpdateCategories(categories);
            }
        },
        // 保存してpage_keyを取得する
        saveAndGetPageKey: async function (editName, categoryData, shouldPublish = true) {
            let pageKey = null;
            let message = this.exception_error_message;
            try {
                this.$_loading();
                const response = await axios.post('/item/category', {
                    _method: 'PUT',
                    name: editName,
                    page_key: categoryData.page_key,
                    parent_page_key: categoryData.parent_page_key,
                    depth: categoryData.depth,
                    order: categoryData.order,
                    should_publish: shouldPublish,
                });
                if (response.data.status === 'OK') {
                    pageKey = response.data.data.page_key;
                    // エラーメッセージを空にする
                    message = '';
                } else {
                    message = response.data.message;
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            this.$_unloading();
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                }, this.$parent);
            }
            return pageKey;
        },
        // カテゴリ名更新前処理
        beforeUpdateCategories: async function (event) {
            // カスタムバリデーションセット
            if (/テスト|test/.test(this.edit_name)) {
                this.$refs.categoryNameInput.setCustomValidity('「テスト・test」の文字があると開店審査に通りません');
            }

            // HTML5のバリデーションエラーの場合はそのままフォーム送信する
            if (!event.target.form.checkValidity()) {
                return;
            }
            event.preventDefault();

            try {
                // 反映予約有無をチェック
                const existsReservation = await this.existsDeployReservation();
                if(existsReservation) {
                    // 予約あり
                    this.openReserveDeployConfirmModal();
                    return;
                }
                // 予約なし
                this.updateCategories(true);

            } catch (e) {
                const message = this.getCatchMessage(e);
                if (message) {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: message,
                    }, this.$parent);
                }
            }
        },
        // 対象カテゴリ名を更新して全カテゴリを更新
        updateCategories: async function (shouldPublish = true) {
            // 変更がなければ抜ける
            if (this.edit_name === this.name) {
                this.close();
                return;
            }

            // ページキーを更新する
            this.edit_page_key = await this.saveAndGetPageKey(this.edit_name, this.category_data, shouldPublish);
            if (!this.edit_page_key) {
                return;
            }

            // 全カテゴリを更新する
            const categories = this.getUpdateCategories();
            this.emitUpdateCategories(categories);
            this.$nextTick(function() {
                this.close();
            });
        },
        // 対象カテゴリ名を更新した全カテゴリリストを取得
        getUpdateCategories: function () {
            // 全カテゴリリストの対象データのカテゴリ名を変更する
            let categories = _.cloneDeep(this.categories);
            const index = categories.findIndex(category => category.page_key === this.category_data.page_key);
            let category = categories[index];
            category.name = this.$_unEscape(this.edit_name.replace(/;amp;/g, ';'));
            category.page_key = this.edit_page_key;
            categories[index] = category;
            return categories;
        },
        // 新規追加したカテゴリを保存しなかった場合は削除する
        getDeleteCategories: function () {
            let newCategories = [];
            const categories = _.cloneDeep(this.categories);
            for (const i in categories) {
                let category = categories[i];
                if (category.depth === this.category_data.depth &&
                    category.order === this.category_data.order &&
                    category.parent_page_key === this.category_data.parent_page_key
                ) {
                    continue;
                }
                newCategories.push(category);
            }
            return newCategories;
        },
        // 反映予約確認モーダルを開く
        openReserveDeployConfirmModal: async function () {
            this.should_open_reserve_deploy_confirm_modal = true;
            await this.$nextTick(function() {
                this.$refs.modalReserveDeployConfirm.open();
            }, this);
        },
        // -------------------------
        // emit
        // -------------------------

        // 親に通知
        emitUpdateCategories: function (categories) {
            this.$emit('update:categories', categories);
        },
        // カテゴリ選択を通知する
        emitSelectedCategory: function () {
            this.$emit('selected-category', this.category_data.page_key);
        },
        // 削除ボタンクリックを通知する
        emitClickedDeleteBtn: function () {
            let params =  {
                'categoryName' : this.edit_name,
                'pageKey' : this.edit_page_key,
            };
            this.$emit('clicked-delete-btn', params);
        },
    }
};
